module.exports = __webpack_public_path__ + "static/img/modal_bgen.1d4f460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgen.png
// module id = szsq
// module chunks = 1